import { take, takeLatest } from "redux-saga/effects";
import * as actions from "../../App/ExportedScormPackages/actions";
import * as sagas from "../../App/ExportedScormPackages/reducer/sagas";

export function* watchDeleteScormPackage() {
  yield takeLatest(
    actions.Action.DELETE_SCORM_PACKAGE,
    sagas.deleteScormPackage({
      onFailure: actions.deleteScormPackageFailure,
      onSuccess: actions.deleteScormPackageSuccess,
    })
  );
}

export function* watchFetchExportedScormPackages() {
  yield takeLatest(
    actions.Action.FETCH_EXPORTED_SCORM_PACKAGES,
    sagas.fetchExportedScormPackages({
      onFailure: actions.fetchExportedScormPackagesFailure,
      onSuccess: actions.fetchExportedScormPackagesSuccess,
    })
  );
}

export function* watchMount() {
  yield take(actions.Action.MOUNT);
}

export function* watchUnmount() {
  yield take(actions.Action.UNMOUNT);
}
